// Shared spreadsheet styles for the time-entry grid and the approval review grid,
// so both look identical.
export const TE_STYLES = `
.te-wrap { font-size:13px; color:#1f2937; }
.te-bar { display:flex; justify-content:space-between; align-items:center; margin:0 0 10px; }
.te-bar-left { display:flex; align-items:center; gap:10px; }
.te-bar-total { font-size:18px; font-weight:650; color:#111827; font-variant-numeric:tabular-nums; }
.te-bar-unit { font-size:13px; font-weight:500; color:#9aa0a6; margin-left:1px; }
.te-tiles { flex-wrap:wrap; }
.te-tile { background:#f7f8fa; border:1px solid #eceef1; border-radius:9px; padding:7px 14px; }
.te-tile-label { font-size:10.5px; color:#8b909a; font-weight:600; text-transform:uppercase; letter-spacing:.03em; }
.te-tile-val { font-size:17px; font-weight:650; color:#111827; font-variant-numeric:tabular-nums; line-height:1.25; }
.te-tile-val span { font-size:11px; font-weight:500; color:#9aa0a6; margin-left:3px; }
.te-tile.bill .te-tile-val { color:#15803d; }
.te-tile.nonbill .te-tile-val { color:#6b7280; }
.te-submit { background:#5b5bd6; color:#fff; border:none; border-radius:7px; padding:8px 16px; cursor:pointer; font-weight:600; font-size:13px; }
.te-submit:hover { background:#4d4dc4; }
.te-submit:disabled { background:#d1d5db; cursor:not-allowed; }
.te-banner { margin:0 0 10px; padding:8px 12px; border-radius:7px; font-size:13px; }
.te-banner-ok { background:#dcfce7; color:#166534; }
.te-banner-err { background:#fee2e2; color:#991b1b; }
.te-loading { padding:24px; color:#6b7280; }
/* Stopwatch, docked top-right of the page. Narrow on purpose: it sits beside
   the period controls and must never push the grid around. */
.te-timer { width:238px; background:#fff; border:1px solid #e6e8eb; border-radius:9px; padding:10px 12px; box-shadow:0 2px 8px rgba(0,0,0,.05); }
.te-timer-head { display:flex; align-items:baseline; justify-content:space-between; margin-bottom:7px; }
.te-timer-title { font-size:10.5px; font-weight:600; color:#8b909a; text-transform:uppercase; letter-spacing:.03em; }
.te-timer-clock { font-size:17px; font-weight:650; color:#111827; font-variant-numeric:tabular-nums; }
.te-timer-clock.paused { color:#9aa0a6; }
.te-timer-row { display:grid; grid-template-columns:58px 1fr; align-items:center; gap:4px; margin-bottom:4px; }
.te-timer-row label { font-size:11px; color:#8b909a; }
.te-timer-row .te-in { border:1px solid #e6e8eb; border-radius:5px; padding:3px 6px; font-size:12px; }
/* Stop & add takes its own row; Pause and Discard share the next one, so the
   three of them are never squeezed into 238px. */
.te-timer-btns { display:flex; flex-wrap:wrap; gap:6px; margin-top:7px; }
.te-timer-go { flex:1 1 100%; background:#5b5bd6; color:#fff; border:none; border-radius:6px; padding:6px 10px; cursor:pointer; font-weight:600; font-size:12px; }
.te-timer-go:hover { background:#4d4dc4; }
.te-timer-go:disabled { background:#d1d5db; cursor:not-allowed; }
.te-timer-x { flex:1 1 0; background:#f3f4f6; color:#6b7280; border:none; border-radius:6px; padding:6px 10px; cursor:pointer; font-size:12px; }
.te-timer-x:hover { background:#e5e7eb; }
.te-timer-stale { font-size:12px; color:#92400e; background:#fffbeb; border-radius:6px; padding:7px 8px; }
.te-timer-ok { margin-top:7px; font-size:11.5px; color:#166534; }
.te-timer-err { margin-top:7px; font-size:11.5px; color:#991b1b; }
/* Sticks below the fixed TopBar so the clock stays readable while you scroll. */
.te-timer-dock { position:sticky; top:80px; flex:0 0 auto; }
.te-frame { border:1px solid #e6e8eb; border-radius:9px; }
.te-table { width:100%; border-collapse:collapse; table-layout:fixed; background:#fff; }
.te-table th { font-size:13px; font-weight:600; color:#3c4149; text-align:left; padding:9px 9px; background:#fbfbfc; border-bottom:1px solid #e6e8eb; position:sticky; top:64px; z-index:5; }
.te-table th.te-num { text-align:right; }
/* The drag strip is invisible; the hairline inside it is what tells you the
   column can be resized at all. Widened to 9px so it is not a pixel hunt. */
.te-resize { position:absolute; top:0; right:0; width:9px; height:100%; cursor:col-resize; }
.te-resize::after { content:""; position:absolute; right:4px; top:7px; bottom:7px; width:1px; background:#d5d8dd; }
.te-resize:hover { background:#e6e9ff; }
.te-resize:hover::after { background:#5b5bd6; top:3px; bottom:3px; width:2px; }
.te-cell { border-right:1px solid #f1f2f4; border-bottom:1px solid #f1f2f4; padding:0; height:29px; vertical-align:middle; }
.te-in { width:100%; border:none; outline:none; background:transparent; padding:5px 9px; font:inherit; font-size:13px; color:#1f2937; box-sizing:border-box; }
.te-in::placeholder { color:#c4c8ce; }
.te-in:focus { background:#eef2ff; box-shadow: inset 0 0 0 1.5px #5b5bd6; border-radius:3px; }
.te-in:disabled { -webkit-text-fill-color:#6b7280; color:#6b7280; cursor:default; }
select.te-in { appearance:none; -webkit-appearance:none; cursor:pointer; }
.te-num, .te-num-cell { text-align:right; font-variant-numeric:tabular-nums; }
.te-notes { padding:5px 9px; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; cursor:text; }
.te-notes-empty { color:#c4c8ce; }
.te-cp { position:relative; }
.te-cp-list { position:absolute; top:100%; left:0; right:0; margin-top:2px; background:#fff; border:1px solid #d9dce1; border-radius:7px; box-shadow:0 10px 28px rgba(0,0,0,.14); z-index:50; max-height:220px; overflow-y:auto; }
.te-cp-item { padding:6px 10px; font-size:13px; cursor:pointer; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; color:#1f2937; }
.te-cp-item:hover { background:#eef2ff; }
.te-cp-hi { background:#e0e7ff; }
.te-cp-hi:hover { background:#e0e7ff; }
.te-cp-empty { padding:6px 10px; font-size:12px; color:#9aa0a6; }
/* The create row: an action, not one of the client's tasks, so it is set off
   from the list above it rather than reading as another option. */
.te-cp-new { border-top:1px solid #e5e7eb; color:#2563eb; font-weight:600; }
/* A year the task dictates: readable, obviously not yours to type in. */
.te-in-locked { background:#f3f4f6; color:#6b7280; cursor:default; }
.te-row:hover { background:#fafbfc; }
.te-status { padding:0 9px; }
.te-save { font-size:11px; color:#b6bbc3; }
.te-del { text-align:center; }
.te-x { border:none; background:transparent; color:#d4d7dc; cursor:pointer; font-size:12px; opacity:0; line-height:1; }
.te-row:hover .te-x { opacity:1; }
.te-x:hover { color:#dc2626; }
.te-day td { background:#e9ebef; border-top:2px solid #cbd0d6; border-bottom:1px solid #d7dbe0; padding:7px 10px; font-weight:700; font-size:12px; color:#374151; letter-spacing:.03em; text-transform:uppercase; }
.te-add td { padding:0; border-bottom:1px solid #f1f2f4; }
.te-add-btn { width:100%; text-align:left; border:none; background:transparent; color:#aab; cursor:pointer; padding:5px 10px; font-size:12px; }
.te-add-btn:hover { color:#5b5bd6; background:#fafbfc; }

/* read-only review grid */
.te-ro { padding:5px 9px; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; }
.te-ro-muted { color:#b6bbc3; }
.te-act { display:flex; gap:6px; padding:0 9px; }
.te-act button { border:1px solid #d6d9de; background:#fff; border-radius:5px; padding:3px 9px; font-size:12px; cursor:pointer; color:#3c4149; }
.te-act button:hover { background:#fafbfc; }
.te-sendback { color:#991b1b !important; border-color:#f4b4b4 !important; }
.te-sendback:hover { background:#fef2f2 !important; }
.te-approve-wk { background:#16a34a; color:#fff; border:none; border-radius:7px; padding:8px 16px; cursor:pointer; font-weight:600; font-size:13px; }
.te-approve-wk:hover { background:#15803d; }
.te-approve-wk:disabled { background:#d1d5db; cursor:not-allowed; }
.te-emp { padding:6px 10px; border:1px solid #d1d5db; border-radius:7px; font-size:13px; background:#fff; cursor:pointer; color:#1f2937; }

/* calendar month view */
.cal { width:100%; border-collapse:collapse; table-layout:fixed; background:#fff; }
.cal th { font-size:12px; font-weight:600; color:#3c4149; padding:7px 8px; background:#fbfbfc; border:1px solid #e6e8eb; text-align:left; position:sticky; top:64px; z-index:5; }
.cal th.cal-num { text-align:right; }
.cal td { border:1px solid #e6e8eb; vertical-align:top; padding:0; }
.cal-dayhdr { display:flex; justify-content:space-between; align-items:baseline; padding:2px 6px 0; }
.cal-date { font-size:10px; color:#aab0b8; }
.cal-dayttl { font-size:10px; color:#6b7280; font-weight:700; font-variant-numeric:tabular-nums; }
.cal-daybox { max-height:96px; overflow-y:auto; padding:2px 3px 4px; scrollbar-width:thin; scrollbar-color:transparent transparent; }
.cal-daybox:hover { scrollbar-color:#cbd0d6 transparent; }
.cal-daybox::-webkit-scrollbar { width:6px; }
.cal-daybox::-webkit-scrollbar-track { background:transparent; }
.cal-daybox::-webkit-scrollbar-thumb { background:transparent; border-radius:3px; }
.cal-daybox:hover::-webkit-scrollbar-thumb { background:#cbd0d6; }
.cal-chip { display:block; font-size:12px; padding:3px 7px; margin:2px 0; border-radius:5px; cursor:pointer; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; }
.cal-chip:hover { filter:brightness(0.96); }
.cal-chip.s-submitted { background:#fef3c7; color:#92400e; }
.cal-chip.s-approved { background:#dcfce7; color:#166534; }
.cal-chip.s-rejected { background:#fee2e2; color:#991b1b; }
.cal-chip.s-draft { background:#eef2ff; color:#3730a3; }
.cal-total { text-align:right; font-variant-numeric:tabular-nums; font-weight:650; padding:8px; vertical-align:middle; color:#111827; }
.cal-actions { padding:8px; vertical-align:middle; }
.cal-act { display:flex; gap:6px; align-items:center; flex-wrap:wrap; }
.cal-btn { border:none; border-radius:6px; padding:5px 12px; font-size:12px; font-weight:600; cursor:pointer; white-space:nowrap; }
.cal-btn-approve { background:#16a34a; color:#fff; }
.cal-btn-approve:hover { background:#15803d; }
.cal-btn-approve:disabled { background:#eef0f2; color:#b6bbc3; cursor:default; }
.cal-btn-sb { background:#fff; color:#b4424a; border:1px solid #f0c4c4; }
.cal-btn-sb:hover { background:#fef2f2; }
.cal-btn-submit { background:#5b5bd6; color:#fff; }
.cal-btn-submit:hover { background:#4d4dc4; }

/* entry detail modal */
.te-modal-overlay { position:fixed; inset:0; background:rgba(17,24,39,.4); display:flex; align-items:center; justify-content:center; z-index:4000; }
.te-modal { background:#fff; border-radius:11px; padding:18px 20px; width:400px; max-width:92vw; box-shadow:0 16px 50px rgba(0,0,0,.25); }
.te-modal-head { display:flex; justify-content:space-between; align-items:center; margin-bottom:10px; }
.te-modal-head h3 { margin:0; font-size:16px; color:#111827; }
.te-modal-x { border:none; background:transparent; font-size:18px; color:#9aa0a6; cursor:pointer; line-height:1; }
.te-modal-row { display:flex; justify-content:space-between; gap:12px; padding:6px 0; border-bottom:1px solid #f1f2f4; font-size:13px; }
.te-modal-label { color:#9097a1; }
.te-modal-val { color:#1f2937; text-align:right; }
.te-modal-notes { margin-top:10px; font-size:13px; white-space:pre-wrap; color:#1f2937; background:#f9fafb; border-radius:7px; padding:9px 11px; }
`;
